'use client';

import { c as _c } from "react/compiler-runtime";
import CommentTextarea from '@/app/[locale]/(worlds)/[roomId]/components/CommentTextarea';
import ViverseAvatar from '@/components/ViverseAvatar';
import { COMMENT_MAXIMUM_CHARACTERS } from '@/constants/comment';
import { useConfigsContext } from '@/context/ConfigsContext';
import { cn } from '@/lib/utils';
import { useState } from 'react';
import { useIsClient, useMediaQuery } from 'usehooks-ts';
function AddCommentField(t0) {
  const $ = _c(18);
  const {
    addComment
  } = t0;
  const [value, setValue] = useState("");
  const {
    store
  } = useConfigsContext();
  const isTablet = useMediaQuery("(min-width: 768px)");
  const isClient = useIsClient();
  const [isLoading, setIsLoading] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      setValue(e.target.value);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleChange = t1;
  let t2;
  if ($[1] !== addComment || $[2] !== value) {
    t2 = async () => {
      setIsLoading(true);
      await addComment(value);
      setValue("");
      setIsLoading(false);
    };
    $[1] = addComment;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleAdd = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("flex min-h-[34px] justify-between gap-2 align-middle md:min-h-[48px] md:gap-4");
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = isClient && isTablet ? "M" : "S";
  const t5 = isClient ? store?.profile?.avatarSnapshot : "";
  const t6 = store?.profile?.displayName;
  let t7;
  if ($[5] !== t4 || $[6] !== t5 || $[7] !== t6) {
    t7 = <ViverseAvatar size={t4} imageUrl={t5} name={t6} />;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = isClient && isTablet ? "M" : "S";
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = cn("md:min-h-[48px] md:gap-4");
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== handleAdd || $[11] !== isLoading || $[12] !== t8 || $[13] !== value) {
    t10 = <CommentTextarea textAreaElementId="add-comment" value={value} submitButtonSize={t8} containerClassName={t9} className="md:px-5 md:py-3" onChange={handleChange} onSubmit={handleAdd} maxLength={COMMENT_MAXIMUM_CHARACTERS} disabled={isLoading} />;
    $[10] = handleAdd;
    $[11] = isLoading;
    $[12] = t8;
    $[13] = value;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t7) {
    t11 = <div data-component="add-comment-field" className={t3}>{t7}{t10}</div>;
    $[15] = t10;
    $[16] = t7;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
}
export default AddCommentField;